import { SxProps, Theme } from '@mui/system';

export default {
  create: {
    ':hover': {
      cursor: 'pointer',
    },
  },
  searchField: { '& .MuiInputBase-root': { borderRadius: 0 } },
} satisfies Record<string, SxProps<Theme>>;
